import type { DataChoice, FieldViewProps } from '../../types'
import type SelectController from './Controller'

import React, { useMemo } from 'react'
import { prop, uniqBy } from 'lodash/fp'

import SelectField from '../../components/SelectField'
import { isArrayOperation, isBooleanOperation } from '../../utils/utils'

type SelectViewProps = FieldViewProps<SelectController>
export default function SelectView({
	field,
	invalidMessage,
	storedValue,
	onChange,
	disabled,
	locale,
}: SelectViewProps) {
	const { useSelectOptions } = field
	const { operation } = storedValue
	const selectOptions = useSelectOptions?.() || { data: [] }

	const options: DataChoice[] = useMemo(
		() => uniqBy(prop('value'), selectOptions.data || []) || [],
		[storedValue, selectOptions.data]
	)

	const handleChange = (value: string) => {
		if (isBooleanOperation(operation)) {
			onChange({ operation, value: '1' })
		} else if (isArrayOperation(operation)) {
			onChange({ operation, value: String(value) })
		} else {
			onChange({ operation, value })
		}
	}
	const isInvalid = Boolean(invalidMessage)

	return (
		<div className='col-span-3'>
			<SelectField
				locale={locale}
				data-testid='query-builder-value-select'
				isLoading={selectOptions.isLoading}
				className='w-full'
				onChange={handleChange}
				value={storedValue.value}
				invalid={isInvalid}
				disabled={disabled}
				placeholder={field.placeholder || locale.getSelectValuePlaceholder()}
				options={options}
			/>
		</div>
	)
}
